import PropTypes from "prop-types";
import { alignItems } from "../../consts";

import FlexContainers from "../Containers/FlexContainers";
import WrapperContainer from "../Containers/WrapperContainer";
import RadioInput from "../RadioGroup/RadioInput";
import { Label, RadioInputWrapper } from "./styled";

const RadioOptionsSelector = ({ title, name, options, selectedId, disabled, onChange }) => {
  return (
    <WrapperContainer
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      gap={8}
      width={"100%"}>
      {title && <Label>{title}</Label>}
      {options?.map((option) => {
        const { id } = option;
        const isSelected = id === selectedId;

        return (
          <RadioInputWrapper
            key={id}
            isSelected={isSelected}
            Container={FlexContainers.FlexColumnStart}
            alignItems={alignItems.start}
            gap={16}
            onClick={() => onChange(id)}
            width={"100%"}>
            <RadioInput
              id={id}
              name={name}
              checkedId={selectedId}
              onCheck={onChange}
              disabled={disabled}>
              {option.Component}
            </RadioInput>
          </RadioInputWrapper>
        );
      })}
    </WrapperContainer>
  );
};

RadioOptionsSelector.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      Component: PropTypes.node.isRequired
    })
  ).isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

export default RadioOptionsSelector;
